import Images from "../assets/images/index";

const { createSo, reports } = Images;
export const sideBarMenuConfig = [
  {
    id: 1,
    title: "Service Order",
    icon: createSo,
    route: "/dashboard",
    isActive: false,
  },
  {
    id: 2,
    title: "SO Creation",
    icon: reports,
    route: "/orders",
    isActive: false,
  },
  {
    id: 3,
    title: "Reports",
    icon: reports,
    route: "/reports",
    isActive: false,
  },
];

export const sideBarMenuSecondConfig = [
  {
    id: 1,
    title: "Service Order",
    icon: createSo,
    route: "/dashboard",
    isActive: false,
  },
  {
    id: 2,
    title: "Reports",
    icon: reports,
    route: "/reports",
    isActive: false,
  },
];
